<template>
  <div class="home">
    <ListProductInventory
    :inventaireHead="inventaireHead"
    :list="listProducts"
    :listInventaireProductsAverageQty="listInventaireProductsAverageQty"
    :frontEndMessages="frontEndMessages"
    @onCreateInventaireProducts="createInventaireProducts"/>
  </div>
</template>

<script>
// @ is an alias to /src
import services from 'services';
import moment from 'moment';
import _ from 'lodash';
import ListProductInventory from '@/components/Inventaire/ListProductInventory.vue';

export default {
  components: {
    ListProductInventory,
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('inventaire/fetchProductsByStore');
    this.$store.dispatch('inventaire/fetchInventaireByStore');

    // setTimeout(() => {  this.testValue = 'TOTO'; }, 5000);
    await this.$store.dispatch('inventaire/fetchProductsAverageQtyByStore');

    /* Here we use the service directly. You might prefer to use the store instead */
    // this.listProducts = await services.ProductService.getProductsByStore('5013');
    // this.listProducts = this.$store.getters['products/listProducts'];
    // console.log('this.listProducts');
    // console.log('inventaire/listInventaireProductsByFamily');
    // console.log(this.$store.getters['inventaire/listInventaireProductsByFamily']);

    this.frontEndMessages = await services.InventaireService
      .getFrontEndMessages();

    this.loading = false;
  },
  computed: {
    listProducts() {
      return this.$store.getters['inventaire/listInventaireProductsByFamily'];
    },
    inventaireHead() {
      return this.$store.getters['inventaire/inventaireHead'];
    },
    listInventaireProductsAverageQty() {
      return this.$store.getters['inventaire/listInventaireProductsAverageQty'];
    },
  },
  data() {
    return {
      loading: false,
      testValue: 'X',
      polling: null,
      frontEndMessages: [],
      // valConso: 0,
      // listProducts: [],
      // fakeCustomers: [],
    };
  },
  methods: {
    async createInventaireProducts() {
      await this.$store.dispatch('inventaire/fetchInventaireByStore');
      await this.$store.dispatch('inventaire/fetchProductsByStore');
      if (this.importEnabled() === true) {
        console.log('importEnabled OUI !!!!');
        const loader = this.$loading({
          lock: true,
          text: "Génération de l'inventaire en cours",
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const shopId = this.$store.getters['$hbui/shopAuth/currentShopId'];
        const res = await services.InventaireService
          .createInventaireProductsFromFront(
            shopId,
            this.inventaireHead.inventoryId,
            this.$store.getters['auth/currentUserId'],
          );
        if (res === true) {
          await this.$store.dispatch('inventaire/fetchProductsByStore');
        } else {
          this.$message({
            showClose: true,
            message: "Une erreur s'est produite",
            type: 'error',
            duration: 6000,
          });
        }

        loader.close();
      } else {
        console.log('importEnabled NON !!!!');
        console.log(this.inventaireHead);
        let messageAlert = '';
        if (this.inventaireHead.dateBeg) {
          let dateBeg = this.inventaireHead.dateBeg.toDate();
          dateBeg = moment(dateBeg);
          dateBeg = dateBeg.format('DD/MM/YYYY [à] HH:mm');
          messageAlert = `Prochain inventaire le ${dateBeg}, réessayez à ce moment-là.`;
        } else {
          const justValidated = await services.InventaireService
            .checkIfCurrentInventaireValidated();
          if (justValidated !== false) {
            messageAlert = `L'inventaire du ${justValidated} a déjà été clôturé.`;
          }
        }
        this.$alert(`Aucun inventaire trouvé pour le moment.<br/>${messageAlert}`,
          'Aucun inventaire', {
            confirmButtonText: 'OK',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          });
      }
    },
    importEnabled() {
      let status = false;
      if (this.inventaireHead.status !== undefined
        && this.inventaireHead.status === 'A') {
        status = true;
      }
      let dateBegBefore = false;
      if (this.inventaireHead.dateBeg) {
        let dateBeg = this.inventaireHead.dateBeg.toDate();
        dateBeg = moment(dateBeg);
        // console.log(dateBeg);
        if (moment().isAfter(dateBeg)) {
          dateBegBefore = true;
        }
      }
      let dateEndAfter = false;
      if (this.inventaireHead.dateEnd) {
        let dateEnd = this.inventaireHead.dateEnd.toDate();
        dateEnd = moment(dateEnd);
        // console.log(dateBeg);
        if (moment().isBefore(dateEnd)) {
          dateEndAfter = true;
        }
      }
      return _.isEmpty(this.listProducts)
        && status
        && dateBegBefore
        && dateEndAfter;
    },
    pollData() {
      this.polling = setInterval(async () => {
        console.log('execution du set interval');
        this.frontEndMessages = await services.InventaireService
          .getFrontEndMessages();
      }, 900000);
    },
  },
  beforeDestroy() {
    // console.log('on destroy  set interval');
    clearInterval(this.polling);
  },
  created() {
    this.pollData();
  },
};
</script>
